// src/api/consultation.js
import http from "./http";

// ─── Public (AllowAny) ───────────────────────────────────────────────

/** ارسال فرم مشاوره از صفحه Home */
export const submitHomeConsultation = (data) =>
  http.post("/support/consultation/submit/home/", data);

/** ارسال فرم تماس با ما از صفحه ContactUs */
export const submitContactConsultation = (data) =>
  http.post("/support/consultation/submit/contact/", data);

// ─── Admin / Support ─────────────────────────────────────────────────

/** لیست همه فرم‌های مشاوره — فیلتر اختیاری: source=home|contact */
export const getConsultations = (params) =>
  http.get("/support/consultation/", { params });

/** جزئیات یک فرم مشاوره */
export const getConsultationDetail = (id) =>
  http.get(`/support/consultation/${id}/`);

/** ثبت کامنت روی یک فرم (با امکان آپلود فایل) */
export const addConsultationComment = (id, formData) =>
  http.post(`/support/consultation/${id}/comments/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
